import { render, staticRenderFns } from "./ModalConfirmationResign.vue?vue&type=template&id=a4358fec&"
import script from "./ModalConfirmationResign.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmationResign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports